module.exports = __webpack_public_path__ + "img/happy-kids-home-02-darkgreen.92881e2.svg";